import echarts from 'echarts'
import merge from 'lodash/merge'
let setAdaption = function (size, setPro) {
    if(!setPro){
        // 默认值
        return 10 * size
    }
    return setPro * size;
};
let chart = null;
export const barOption = (setPro, element_id, data) => {
    if(!data) return
    if (chart === null) {
        chart = echarts.init(document.getElementById(element_id));
        chart.timer = null;
    }
    const seriesData = data
    let bgBarData = []
    for(var i = 0; i < seriesData.data.length; i++) {
        bgBarData.push("100")
    }
    const myOption = {
        series: [{data:seriesData.data}],
        xAxis: [{data:seriesData.xAxisData}]
    }
    let option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
                type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            },
            position: function(pt, params, dom, rect, size) {
                if(parseFloat(size.viewSize) - parseFloat(pt[0])<= parseFloat(size.contentSize)){
                  return [parseFloat(pt[0])-parseFloat(size.contentSize), '30%'];
                }
                return [pt[0], '30%'];
            },
            formatter: function (params) {
                var str = '';//声明一个变量用来存储数据
                for (var i = 0; i < 1; i++) {
                    str +=  `<span style="display:inline-block;width:10px;height:10px;background-color:` + params[0].color + `;margin-right:3px"></span> <span style="display:inline-block;">`+ params[0].name + ' : ' + '&nbsp;' + params[0].data + '分' + `</span>` + '</br>';
                }
                return str;
            },
            textStyle: {
                color: "rgba(255, 255, 255, 1)",
                fontSize: setAdaption(0.65, setPro),
                lineHeight: setAdaption(1, setPro),
            },
        },
        legend: {
            show: false
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '15%',
            containLabel: true
        },
        xAxis: [{
             type: 'category',
           //x轴线
              axisLine: {
                show: true,
                lineStyle: {
                  color: "rgba(255, 255, 255, 0.16)",
                  opacity: 1,
                  width: setAdaption(0.1, setPro),
                  type: "solid",
                },
              },
              //刻度
              axisTick: {
                show: false
              },
              axisLabel: {
                textStyle: {
                  color: "rgba(255, 255, 255, 1)",
                  fontSize: setAdaption(0.6, setPro),
                },
                // rotate: 60,
                fontSize: setAdaption(0.6, setPro),
              },
            data: [],
        }],
        yAxis: [
            {
                type: 'value',
                // gridIndex: 0,
                // min:0,
                // max:100,
                // minInterval: 25,
                // splitNumber: 5,
                //轴线
                axisLine: {
                    show: false,
              },
                axisTick: {
                    show: false,
              },
               splitLine: {
                lineStyle: {
                  color: "rgba(216, 216, 216, .2)",
                  type: "dotted",
                },
              },
                axisLabel:{
                    textStyle: {
                        color: "rgba(255, 255, 255, 1)",
                        fontStyle: "normal",
                      fontSize: setAdaption(0.6, setPro),
                    },
                },
                name: '分',
                nameLocation: "end",
                nameTextStyle: {
                    color: "rgba(255, 255, 255, 1)",
                 fontSize: setAdaption(0.6, setPro),
                    padding: [0, 0, 0, -26],
                },
            },
            {
                type: 'value',
                gridIndex: 0,
                // min: min,
                // max: 100,
                // splitNumber: 12,
                splitLine: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    show: false
                },
            }
        ],
        series: [{
                name: '数据条',
                type: 'bar',
                barWidth: setAdaption(1.2, setPro),
                yAxisIndex: 0,
                itemStyle: {
                    normal: {
                        color: 'rgba(24, 144, 255, 1)'
                    },
                },
                data: [],
                zlevel: 11
    
            },
            {
                name: '背景',
                type: 'bar',
                barWidth: setAdaption(1.2, setPro),
                yAxisIndex: 1,
                barGap: '-101%',
                data: bgBarData,
                itemStyle: {
                    normal: {
                        color: 'rgba(24, 144, 255, 0.2)',
                    }
                },
                zlevel: 9
            },
          
        ]
    };
    
    
    const finalSeries = merge(option, myOption)

    chart.setOption(finalSeries)
    let index = 0, data_len = option.series[0].data.length;
    function autoTip() {
        clearInterval(chart.timer)
        chart.timer = setInterval(() => {
            chart.dispatchAction({
                type: 'showTip',
                seriesIndex: 0,
                dataIndex: index
            });
            index++;
            if(index >= data_len){
                index = 0
            } 
        }, 3000)
        chart.on('mousemove', function(e){
            clearInterval(chart.timer)
            chart.dispatchAction({
                type: 'hideTip',
                seriesIndex: 0,
                dataIndex: index-1
            });
            chart.dispatchAction({
                type: 'showTip',
                seriesIndex: 0,
                dataIndex: e.dataIndex
            })
        })
        chart.on('mouseout', function(e){
            clearInterval(chart.timer)
            chart.dispatchAction({
                type: 'hideTip',
                seriesIndex: 0,
                dataIndex: e.dataIndex
            });
            index = e.dataIndex + 1;
            chart.timer = setInterval(() => {
                chart.dispatchAction({
                    type: 'showTip',
                    seriesIndex: 0,
                    dataIndex: index
                });
                index++;
                if (index >= data_len) {
                    index = 0;
                }
            }, 3000)
        })
    }
    autoTip()
    return chart
}